import { Circle, Flex, Rectangle, Skeleton } from '@lokalise/louis';

import { Container, Wrapper } from '../Promo';

type TutorialSkeletonProps = {
    loading?: boolean;
};

const getDescription = (loading: boolean) => (loading ? 'Tutorial loading...' : 'Tutorial failed on loading...');

const TutorialSkeleton = ({ loading = false }: TutorialSkeletonProps) => (
    <Container>
        <Wrapper align="center" wrap="nowrap">
            <Skeleton animated={loading} description={getDescription(loading)}>
                <Flex gap={2} align="center">
                    <Circle size={30} />
                    <Flex gap={1} direction="column">
                        <Rectangle height={16} width={50} />
                        <Rectangle height={16} width={80} />
                    </Flex>
                </Flex>
            </Skeleton>
        </Wrapper>
    </Container>
);

export default TutorialSkeleton;
